import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import './InsuranceVerificationDetails.scss';

type props = {
  outOfPocketFee?: string | number;
  className?: string;
};

export const InsuranceOopSessionFee: React.FC<props> = ({
  outOfPocketFee,
  className,
}: props) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div className={`card-container ${className || ''}`}>
      <Typography variant="size-20" color="color-2">
        {t('insuranceOopSessionFee.title')}
      </Typography>

      <Typography
        variant="size-26"
        weight="bold"
        color="color-2"
        className="mt-3"
      >
        ${outOfPocketFee} {t('insuranceOopSessionFee.amountSuffix')}
      </Typography>

      <Typography variant="size-14" color="color-28" className="mt-2">
        {t('insuranceOopSessionFee.description')}
      </Typography>
    </div>
  );
};
